<div #playerContainer class="videoPlayer">
    <video #video class="videoPlayer__video" playsinline
           [hidden]="!useVideoElement || connectionFailed"
           [controls]="mode === 'playback'"
           (loadstart)="buffering = true" (waiting)="buffering = true" (seeking)="buffering = true"
           (canplay)="buffering = false" (playing)="buffering = false"
           (emptied)="buffering = false" (error)="buffering = false"></video>

    @if (showBufferingSpinner && mode === 'playback' && playbackUrl && buffering) {
        <div class="videoPlayer__buffering">
            <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
        </div>
    }

    <!-- jsmpeg draws into a canvas of its own. -->
    <div #legacyWrapper class="videoPlayer__legacy" [hidden]="useVideoElement || connectionFailed"></div>

    @if (showControls) {
        <div class="videoPlayer__controls">
            <div class="videoPlayer__gradient"></div>
            <div class="videoPlayer__buttons">
                <div [innerHTML]="icons[isPlaying ? 'stop' : 'play']" class="streamingIcon"
                     (click)="togglePlayPause()"></div>
                <div [innerHTML]="icons['fullscreen']" class="streamingIcon"
                     (click)="toggleFullscreen()"></div>
            </div>
        </div>
    }

    @if (statusBadge; as badge) {
        <span class="videoPlayer__status" [attr.data-tone]="badge.tone">
            {{ badge.key | translate: { count: badge.count } }}
        </span>
    }

    @if (showOverlayClose) {
        <button type="button" class="videoPlayer__overlayClose" (click)="toggleFullscreen()"
                [attr.aria-label]="'GENERAL.CLOSE' | translate">
            <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </button>
    }

    @if (showPlaybackHint) {
        <div class="videoPlayer__hint">{{ 'VMS.SELECT_ON_TIMELINE' | translate }}</div>
    }

    @if (connectionFailed) {
        <div class="h-100 w-100 d-flex justify-content-center align-items-center">
            <p class="paragraphText videoPlayer__message">
                {{ (credentialsRejected ? 'CAMERA.WRONG_CREDENTIALS' : 'CAMERA.NO_VIDEO') | translate }}
            </p>
        </div>
    }

    @if (mode === 'live') {
        <urban-loader [localized]="true" [disappearCondition]="videoLoaded || connectionFailed"
                      [borderRadius]="'unset'"></urban-loader>
    }
</div>
